<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input placeholder="请输入内容" v-model="queryInfo.query" clearable @clear="getDeptList">
            <el-button slot="append" icon="el-icon-search" @click="getDeptList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addDialogVisible = true">添加部门</el-button>
        </el-col>
      </el-row>

      <!-- 部门列表区域 -->
      <el-table
        :data="deptlist"
        row-key="Id"
        :tree-props="{children: 'children', hasChildren: 'HasChildren'}"
        border
        lazy
        :load="load"
        stripe>
        <el-table-column label="部门名称" prop="DeptName"></el-table-column>
        <el-table-column label="状态" prop="Status">
          <template slot-scope="scope">
            <span v-if="scope.row.Status == '0'">停用</span>
            <span v-if="scope.row.Status == '1'">正常</span>
          </template>
        </el-table-column>


        <el-table-column label="创建时间" prop="UpdatedAt"></el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.Id)"></el-button>
            </el-tooltip>
            <!-- 新增按钮 -->
            <el-tooltip effect="dark" content="新增" placement="top" :enterable="false">
              <el-button type="warning" icon="el-icon-circle-plus-outline" size="mini" @click="addChildrenDept(scope.row)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-tooltip v-if="scope.row.Id != 1" effect="dark" content="删除" placement="top" :enterable="false">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeDeptById(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加部门的对话框 -->
    <el-dialog title="添加部门" :visible.sync="addDialogVisible" width="40%" @close="addDialogClosed">
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="上级部门" prop="value">
          <el-select ref="elSelect" class="width-100" v-model="addForm.value" placeholder="请选择">
            <el-option
              :value="addForm.value"
              style="height: auto"
            >
              <el-tree
                :data="deptlist"
                node-key="Id"
                :props="defaultProps"
                @node-click="handleNodeClick"
              ></el-tree>
            </el-option>
          </el-select>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="部门名称" prop="DeptName">
              <el-input v-model="addForm.DeptName" placeholder="请输入部门名称"></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="Leader">
              <el-input v-model="addForm.Leader" placeholder="请输入负责人"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="Email">
              <el-input v-model="addForm.Email" placeholder="请输入邮箱地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="Phone">
              <el-input v-model="addForm.Phone" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="addForm.Status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addDept">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改部门的对话框 -->
    <el-dialog title="修改部门" :visible.sync="editDialogVisible" width="40%" @close="editDialogClosed">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="90px">

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="部门名称" prop="DeptName">
              <el-input v-model="editForm.DeptName" placeholder="请输入部门名称"></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="Leader">
              <el-input v-model="editForm.Leader" placeholder="请输入负责人"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="Email">
              <el-input v-model="editForm.Email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="Phone">
              <el-input v-model="editForm.Phone"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="editForm.Status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editDeptInfo">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import { chat_get, chat_post, toForm } from '@/api'
  export default {
    data() {
      return {
        // 树形控件的配置
        defaultProps: {
          children: 'children',
          label: 'DeptName'
        },
        // 获取部门列表的参数对象
        queryInfo: '',
        deptlist: [],
        // 控制添加部门对话框的显示与隐藏
        addDialogVisible: false,
        maps:new Map(),
        // 添加部门的表单数据
        addForm: {
          Status: '1',
          value: '',
          DeptName: '',
          Leader: '',
          Email: '',
          Phone: ''
        },
        // 添加表单的验证规则对象
        addFormRules: {
          DeptName: [
            { required: true, message: '请输入部门名称', trigger: 'blur' },
            {
              min: 2,
              max: 15,
              message: '部门名称的长度在2~15个字符之间',
              trigger: 'blur'
            }
          ],
          value: [
            { required: true, message: '请选择上级部门名称', trigger: 'blur' },
          ],
          Phone: [
            {
              pattern: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,
              message: '请输入正确的手机号码或者座机号',
              trigger: 'blur'
            },
          ],
          Email: [
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/,
              message: '请输入正确的邮箱地址',
              trigger: 'blur',
            },
          ],
        },
        // 控制修改部门对话框的显示与隐藏
        editDialogVisible: false,
        // 查询到的部门信息对象
        editForm: {

        },
        // 修改表单的验证规则对象
        editFormRules: {
          DeptName: [
            { required: true, message: '请输入部门名', trigger: 'blur' },
            {
              min: 2,
              max: 15,
              message: '部门名称的长度在2~15个字符之间',
              trigger: 'blur'
            }
          ],
          Phone: [
            {
              pattern: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,
              message: '请输入正确的手机号码或者座机号',
              trigger: 'blur'
            },
          ],
          Email: [
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/,
              message: '请输入正确的邮箱地址',
              trigger: 'blur',
            },
          ],
        }
      }
    },
    created() {
      this.getDeptList()
    },
    methods: {
      getDeptList() {
        chat_get(`/admin/GetDeptListByPid?pid=0`, {}, res => {
          if(res.status == 200) {
            this.deptlist = res.data
          }
        })
      },
      load(tree, treeNode, resolve) {
        const pid = tree.id;
        this.maps.set(pid,{tree,treeNode,resolve})
        chat_get(`/admin/GetDeptListByPid?pid=${tree.Id}`, {}, res => {
          if(res.status == 200) {
            resolve(res.data)
          }
        })
      },
      getChildList(id) {
        chat_get(`/admin/GetDeptListByPid?pid=${tree.Id}`, {}, res => {
          if(res.status == 200) {
            resolve(res.data)
          }
        })
      },
      addChildrenDept(val) {
        this.addDialogVisible = true
        let childData = {
          DelFlag: val.DelFlag,
          Id: val.Id,
          value: val.DeptName
        }
        Object.assign(this.addForm, childData)
      },
      handleNodeClick(sel) {
        let {Id, Ancestors, DelFlag, Pid} = sel
        Object.assign(this.addForm, {Id, Ancestors, DelFlag, Pid})
        this.addForm.value = sel.DeptName
        this.$refs.elSelect.blur()
      },
      // 监听添加部门对话框的关闭事件
      addDialogClosed() {
        this.$refs.addFormRef.resetFields()
      },
      // 点击按钮，添加新部门
      addDept() {
        let vm = this;
        this.$refs.addFormRef.validate(valid => {
          if (!valid) return
          let {DeptName, Email='', Phone='', Leader='', Status, DelFlag, Id} = vm.addForm
          let params = toForm({
            DeptName,
            DelFlag,
            Email,
            Phone,
            Leader,
            Status,
            Pid: Id
          })
          chat_post('admin/v1/addDept', params, res => {
            this.$message.success('添加部门成功！')
            // 隐藏添加部门的对话框
            this.addDialogVisible = false
            // 重新获取部门列表数据
            this.getDeptList()
          })
        })

      },
      // 展示编辑部门的对话框
      showEditDialog(id) {
        chat_get(`/admin/v1/queryDeptById?Id=${id}`, {}, res => {
          if(res.status == 200) {
            this.editDialogVisible = true
            this.editForm = res.data.MessageContent
          }
        })
      },
      // 监听修改部门对话框的关闭事件
      editDialogClosed() {
        this.$refs.editFormRef.resetFields()
      },
      // 修改部门信息并提交
      editDeptInfo() {
        this.$refs.editFormRef.validate(valid => {
          if (!valid) return
          let params = toForm(this.editForm)
          chat_post('/admin/v1/updateDept', params, res => {
            if(res.status == 200){
              // 关闭对话框
              this.editDialogVisible = false
              // 刷新数据列表
              this.getDeptList()
              // 提示修改成功
              this.$message.success('更新部门信息成功！')
            }
          })
        })
      },
      // 根据Id删除对应的部门信息
      removeDeptById(oneUser) {
        let vm = this;
        this.$confirm( `此操作将删除部门"${oneUser.DeptName}", 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          chat_post(`/admin/v1/deleteDept?Id=${oneUser.Id}`, {}, res => {
            if(res.status == 200) {
              vm.getDeptList()
              const pid = oneUser.Id
              const {tree,treeNode,resolve} = this.maps.get(pid)
              this.$set(this.$refs.table.store.states.lazyTreeNodeMap,pid,[])
              this.load(tree,treeNode,resolve);
              vm.$message({
                type: 'success',
                message: `删除成功!`
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style lang="less" scoped>
  .el-select-dropdown__item {
    padding: 0;
  }
</style>
